const FacetType = {
  NULLENUM: 0,
  ALERT_NAME: 1,
  ALERT_TRIGGERED: 2,
  ALERT_TAGS: 3,
  CHANNEL_TYPE: 4,
  PUSH_STATUS: 5,
  DEVICE_TAGS: 6,
  ALERT_FAVORITE: 7,
  HISTORICAL_ALERT_EVENT: 8,
  NOTIFICATION_GROUP: 9,
  ALERT_SUSPENDED: 10,
  THRESHOLD: 11,
  ALERT_ACKNOWLEDGED: 12,
  DEVICE_SUSPENDED: 13,
  DEVICE_NAME: 14,
  DEVICE_TYPE: 15,
  DEVICE_FIRMWARE_STATUS: 16,
  DEVICE_LINK_CONNECTION: 17,
  ALERT_QUIET_TIME: 18,
  ALERT_NOTIFICATION_TEMPLATES: 19,
  CHANNEL_GROUP_NAME: 20,
  CHANNEL_LAST_READING_TIMESTAMP: 21,
  CHANNEL_LAST_READING_VALUE_COMPARISON: 22,
  CHANNEL_ALERT_COUNT: 23,
  // sensor port not in use
  // SENSOR_PORT:
  DEVICE_ID: 24,
};

export default FacetType;
